import { mapPeCompanyOrderListItemFromApi } from './companyOrders/mapPeCompanyOrderListFromApi';
import { mapPeOrderListItemFromApi } from './orders/mapPeOrderListFromApi';
import mapPeCompanyShortFromApi from './peCompany/mapPeCompanyShortFromApi';

const mapPeRecommendationsFromApi = (
  resp: ApiFetchPeRecommendationsResponse
): PeRecommendations => {
  return {
    investorsOrders: resp.investor_pe_orders.map(mapPeOrderListItemFromApi),
    sharesproOrders: resp.company_pe_orders.map(
      mapPeCompanyOrderListItemFromApi
    ),
    companies: resp.pe_companies.map(mapPeCompanyShortFromApi),
  };
};

export default mapPeRecommendationsFromApi;
